import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage.jsx";

// Admin laddas separat — endast när någon besöker /admin.
const AdminPage = lazy(() => import("./pages/AdminPage.jsx"));

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/admin/*"
        element={
          <Suspense
            fallback={
              <div className="grid min-h-screen place-items-center bg-sand-50 text-navy-700">
                Laddar admin…
              </div>
            }
          >
            <AdminPage />
          </Suspense>
        }
      />
    </Routes>
  );
}
